import React from "react";
import { SmsTosConsentScreen } from "~/features/tos-consent/SmsTosConsentScreen";

const Component = () => {
  return <SmsTosConsentScreen />;
};

export default Component;
